<template>
  <div class="document-upload">
    <slot name="step-summary" />

    <ul class="mt-30 pl-4">
      <li
        v-for="(rule, index) in rules"
        :key="index"
        class="list-disc my-10"
      >
        {{ rule }}
      </li>
    </ul>

    <div class="mt-45">
      <AppFileInput
        v-for="(button, index) in uploadButtons"
        :key="index"
        :value="button.value"
        :error="button.error"
        :document-type="button.documentType"
        :no-file-chosen-text="button.noFileChosenText"
        :required="button.required"
        class="document-upload__input"
        :docs-stand-alone="docsStandAlone"
        :theme="theme"
        @input="$_input_updateState(button.vuexActionFile, $event)"
        @upload-success="uploadSuccess(button.vuexAction, button.dataLayerEvent)"
      >
        <template #icon>
          <FontAwesomeIcon
            icon="camera"
            class="mr-15 text-lg"
          />
          {{ button.title }}
        </template>
      </AppFileInput>
    </div>
  </div>
</template>

<script>
import AppFileInput from '@/components/common/inputs/AppFileInput'
import DataLayer from '@/utilities/data-layer'
import input from '@/mixins/input'

export default {
  name: 'DocumentUpload',

  components: {
    AppFileInput
  },

  mixins: [
    input
  ],

  props: {
    error: {
      type: String,
      default: ''
    },

    rules: {
      type: Array,
      default: () => []
    },

    uploadButtons: {
      type: Array,
      default: () => []
    },

    docsStandAlone: {
      type: Boolean,
      default: false
    },

    theme: {
      type: String,
      default: 'green'
    }
  },

  methods: {
    uploadSuccess (vuexAction, dataLayerEvent) {
      if (dataLayerEvent) DataLayer.pushObject(dataLayerEvent)
      this.$_input_updateState(vuexAction, true)
    }
  }
}
</script>

<style lang='scss' scoped>
.document-upload__input {
  @apply mb-45;

  &:last-child {
    @apply mb-0;
  }
}
</style>
